export const documentsUploadStyles = (theme) => ({})
